import { render, staticRenderFns } from "./Machine.vue?vue&type=template&id=6a067bc8"
import script from "./Machine.vue?vue&type=script&lang=js"
export * from "./Machine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports